<template>
  <div>
    <HttpContentView :endpoint="utilities.path('communities/@/servers/all', communityId)" :params="params">
      <template v-slot:content="{ data }">
        <div class="d-flex align-items-center flex-wrap g-2 mb-3" v-if="data.length > 1">
          <div v-for="server in data" :key="server.id">
            <ButtonView type="normal" color="secondary" size="small" :active="selectedServerId === server.id" @click="selectedServerId === server.id ? selectedServerId = undefined : selectedServerId = server.id">
              <div class="d-flex align-items-center g-2">
                <i class="fa-duotone fa-server" :style="{ color: server.color }"></i>
                <span>{{ server.name }}</span>
              </div>
            </ButtonView>
          </div>
        </div>
      </template>
    </HttpContentView>
    <div class="card">
      <div class="card-body">
        <HttpContentView :endpoint="utilities.path('communities/@/modules/analytics/playtime/total', communityId)" :params="params">
          <template v-slot:content="{ data }">
            <div class="d-flex align-items-center justify-content-between">
              <h3 class="mb-0">{{ translate("total") }}</h3>
              <span class="fw-bold">{{ utilities.formatDuration(data * 3600, true) }}</span>
            </div>
          </template>
        </HttpContentView>
      </div>
    </div>
    <HistoricDateRangePickerView v-model:from="from" v-model:to="to" :min="minimumDate" :max="maximumDate" class="my-4"/>
    <HttpContentView :endpoint="playerId ? utilities.path('players/@/modules/analytics/playtime', playerId) : utilities.path('communities/@/modules/analytics/playtime', communityId)" :params="params">
      <template v-slot:content="{ data }">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-center justify-content-between">
              <span>{{ translate('playtime') }}</span>
              <span class="fw-bold" v-if="data.map(item => item.value).reduce((a, b) => a + b, 0) > 0">{{ utilities.formatDuration(data.map(item => item.value).reduce((a, b) => a + b, 0) * 3600, true) }}</span>
              <span class="fw-bold text-muted" v-else>{{ translate("no.data") }}</span>
            </div>
            <PlaytimeChartView v-if="data.map(item => item.value).reduce((a, b) => a + b, 0) > 0" :data="data" :title="translate('playtime')" color="#f18616" :suffix="translate('hours')"/>
          </div>
        </div>
      </template>
    </HttpContentView>
  </div>
</template>

<script setup>
import {ButtonView, HttpContentView, utilities} from "@/niftybit";
import PlaytimeChartView from "@/systems/modules/analytics/PlaytimeChartView.vue";
import {DateTime} from "luxon";
import HistoricDateRangePickerView from "@/systems/modules/analytics/HistoricDateRangePickerView.vue";
import {computed, ref} from "vue";

const props = defineProps({
  communityId: String,
  playerId: String
});

const selectedServerId = ref(undefined);
const from = ref(DateTime.utc().toLocal().minus({ days: 30 }).startOf("day").toISO());
const to = ref(DateTime.utc().toLocal().minus({ days: 1 }).endOf("day").toISO());

const minimumDate = DateTime.utc().minus({ days: 90 }).toISO();
const maximumDate = DateTime.utc().toLocal().toISO();

const params = computed(() => ({
  playerId: props.playerId,
  serverId: selectedServerId.value,
  timezone: DateTime.utc().toLocal().zone.name,
  from: DateTime.fromISO(from.value).startOf("day").toISO(),
  to: DateTime.fromISO(to.value).endOf("day").toISO()
}));

</script>